import * as msgpack from '@mta/msgpack-js-lib';

export default class B2bPublicServiceClientProxy {
	/** @constructor */
	constructor(msgpackClient) {
		this._msgpackClient = msgpackClient;
	}

	/**
	 * @return {Promise<ExternalUser>}
	 */
	async getConnectedUser() {
		return this._msgpackClient.call(
				'B2bPublicService/GetConnectedUser',
				[
				],
				(is, data) => is.readObject(data, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.user.ExternalUser()))
	}

	/**
	 * @param {LoginCredentials} entry
	 * @return {Promise<!boolean>}
	 */
	async loginExternalUser(entry) {
		return this._msgpackClient.call(
				'B2bPublicService/LoginExternalUser',
				[
					(os) => os.writeObject(entry)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @return {Promise<?string>}
	 */
	async redirectToAppUrl() {
		return this._msgpackClient.call(
				'B2bPublicService/RedirectToAppUrl',
				[
				],
				(is, data) => is.readString(data))
	}

	/**
	 * @param {RegistrationCredentials} entry
	 * @return {Promise<!boolean>}
	 */
	async registerExternalUser(entry) {
		return this._msgpackClient.call(
				'B2bPublicService/RegisterExternalUser',
				[
					(os) => os.writeObject(entry)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} email
	 * @return {Promise<!boolean>}
	 */
	async resendVerificationEmail(email) {
		return this._msgpackClient.call(
				'B2bPublicService/ResendVerificationEmail',
				[
					(os) => os.writeString(email)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} username
	 * @return {Promise<!boolean>}
	 */
	async selectUsername(username) {
		return this._msgpackClient.call(
				'B2bPublicService/SelectUsername',
				[
					(os) => os.writeString(username)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} email
	 * @return {Promise<!boolean>}
	 */
	async sendPasswordResetEmail(email) {
		return this._msgpackClient.call(
				'B2bPublicService/SendPasswordResetEmail',
				[
					(os) => os.writeString(email)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} code
	 * @param {PasswordCredentials} entry
	 * @return {Promise<!boolean>}
	 */
	async updateUserPassword(code, entry) {
		return this._msgpackClient.call(
				'B2bPublicService/UpdateUserPassword',
				[
					(os) => os.writeString(code), 
					(os) => os.writeObject(entry)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} mfaCode
	 * @return {Promise<!boolean>}
	 */
	async verifyMfaCode(mfaCode) {
		return this._msgpackClient.call(
				'B2bPublicService/VerifyMfaCode',
				[
					(os) => os.writeString(mfaCode)
				],
				(is, data) => is.readBoolean(data))
	}

	/**
	 * @param {?string} code
	 * @return {Promise<!boolean>}
	 */
	async verifyUserByCode(code) {
		return this._msgpackClient.call(
				'B2bPublicService/VerifyUserByCode',
				[
					(os) => os.writeString(code)
				],
				(is, data) => is.readBoolean(data))
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.pub.B2bPublicServiceClientProxy', B2bPublicServiceClientProxy);
